import React from 'react';

import { View } from 'react-native-web';
import { Box } from '@styleseat/ui';
import AccountMenu from '../AccountMenu';
import HeaderLinks from '../HeaderLinks';
import ProHeaderDropdown from '../../../provider/navigation/ProHeaderDropdown';
import './HeaderMenu.module.scss';

const HeaderMenu = ({
  providerId,
  referralEntry,
  showReferralEntry,
}: {
  providerId?: number,
  referralEntry?: JSX.Element,
  showReferralEntry?: boolean,
}) => (
  <View styleName="headerMenu">
    <AccountMenu />
    <HeaderLinks />
    {providerId ? (
      <View styleName="proMenu">
        <ProHeaderDropdown providerId={providerId} />
      </View>
    ) : null}
    {showReferralEntry && (
      <Box paddingRight={24} paddingTop={28}>
        {referralEntry}
      </Box>
    )}
  </View>
);

export default HeaderMenu;
